import React from 'react'

export default function AnimeMapManga({ mangaData }) {
    return (
      <div key={mangaData.mal_id} className="center">
               <h2 className='heading'>{mangaData.title}</h2>
               <img className='img' src={mangaData.images.jpg.large_image_url} alt={mangaData.title} />
              </div>
    )
  }